export default __webpack_public_path__ + "static/media/CTechOct22.4ca8e949.svg";